import { useSelector } from 'react-redux';
import { useLandingProfessionalSelect } from '@/hooks/useLandingProfessionalSelect';
import { ProfessionalSelect } from '@/pages/onboarding/landing/ProfessionalSelect';
import { LandingMmg } from '@/pages/onboarding/landing/LandingMmg';
import { RootState } from '@/types/graph';
import { isMmgVariant } from '@/util/mmg';
import { selectEffectiveProfessional } from '@/util/professional';
import { getVisibleWelcomeMessage } from '@aldebaran/common/util/welcomeMessage';

export const LandingProfessionalSelect = () => {
  const {
    mode,
    professional,
    professionals,
    selectedProfessional,
    practice,
    consultationDate,
    handleNavigateNext,
    handleSelectProfessional,
  } = useLandingProfessionalSelect();

  // Active questionnaire variant (covers the public `?variant=` path, which sets
  // graph.variant but not consultation.variant).
  const isMmg = useSelector((state: RootState) =>
    isMmgVariant(state.graph.variant),
  );
  // MMG check-in subtitle: the selected (or default) professional's message.
  const welcomeMessage = useSelector((state: RootState) =>
    getVisibleWelcomeMessage(selectEffectiveProfessional(state)),
  );

  // MMG is on-call care with no doctor to pick, so it gets its own dedicated
  // check-in landing rather than the professional-selection page (ALDO-2540).
  if (isMmg) {
    return (
      <LandingMmg
        practice={practice}
        consultationDate={consultationDate}
        welcomeMessage={welcomeMessage}
        onRegister={handleNavigateNext}
      />
    );
  }

  return (
    <ProfessionalSelect
      mode={mode}
      professional={professional}
      professionals={professionals}
      selectedProfessional={selectedProfessional}
      practice={practice}
      onSelectProfessional={handleSelectProfessional}
      onPrepareConsultation={handleNavigateNext}
    />
  );
};
